const ComplaintsPolicy = () => {
    return (
        <div className="w-full container pt-10">
            <div className="border border-black/15 rounded-md w-full bg-white p-6 sm:p-8">
                <h1 className="text-3xl font-bold border-b pb-5 mb-5">
                    Nile Wise Complaints Policy
                </h1>

                <div className="space-y-6 text-textPrimary">
                    <section>
                        <h2 className="text-xl font-bold mb-2">How to Make a Complaint</h2>
                        <p className="mb-2">
                            If you are dissatisfied with our product or service, you can submit a formal complaint through our official support channels. To ensure your issue is documented and resolved efficiently, we encourage you to submit a ticket directly through our online Support Center.
                        </p>
                        <p>
                            Alternatively, you can submit a written complaint or speak with our support team using the contact details below:
                        </p>
                        <ul className="list-disc pl-6 mt-2">
                            <li>
                                Email:{" "}
                                <a href="mailto:Info@nilewisect.com" className="text-primary underline">
                                    Info@nilewisect.com
                                </a>
                            </li>
                            <li>
                                Dedicated Support Hotline & WhatsApp:{" "}
                                <a href="tel:+201094234423" className="text-primary underline">
                                    +201094234423
                                </a>{" "}
                                or{" "}
                                <a href="tel:+201024111944" className="text-primary underline">
                                    +201024111944
                                </a>
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold mb-2">Timeframes for Acknowledgement and Response</h2>
                        <p>
                            We are committed to investigating complaints thoroughly and promptly. You will receive an acknowledgement of your complaint within 2 working days. A full response and resolution will be provided within 10 working days.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold mb-2">Treatment of Complaints</h2>
                        <p>
                            All complaints will be treated with strict confidentiality. Your complaint will be reviewed objectively by the Student Support Manager and the relevant Department Head.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold mb-2">Right to Appeal</h2>
                        <p>
                            If you are not satisfied with the outcome of your complaint, you have the right to appeal. Appeals must be submitted in writing within 5 working days of receiving the decision, and they will be reviewed by the Managing Director.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold mb-2">Escalation to Accrediting Bodies</h2>
                        <p className="mb-3">
                            NileWise is committed to resolving all complaints fairly and transparently. We strongly encourage students to exhaust our internal complaints procedure before escalating to any external body, as this allows us the opportunity to address concerns directly and promptly.
                        </p>
                        <p className="mb-3">
                            Any student that wishes to make a complaint to ACCA regarding your institution will be advised to follow your institution's complaints procedure first. If the complaint is not handled to their satisfaction, the student then has the option to escalate their complaint to ACCA. If a student has exhausted both your complaints process and ACCA's, they can escalate to the appropriate regulator. Details of which can be found on the ACCA website at the following link:{" "}
                            <a href="https://www.accaglobal.com/gb/en/footer-toolbar/contact-us/unhappy.html" className="text-primary underline" target="_blank" rel="noopener noreferrer">
                                https://www.accaglobal.com/gb/en/footer-toolbar/contact-us/unhappy.html
                            </a>
                        </p>
                        <p>
                            Similarly, for any other course or qualification offered by NileWise that is accredited by an external body, students who remain unsatisfied after completing our internal complaints procedure are entitled to escalate their complaint to the relevant accrediting organisation.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ComplaintsPolicy;
